import { getEmailPublicBaseUrl } from "@/lib/email/public-base-url";

/** Safe in-app path for post-login redirect (rejects open redirects). */
export function sanitizePostLoginPath(raw: string | null): string {
	if (!raw?.trim()) return "/pools";
	try {
		const u = new URL(raw, "http://localhost");
		const path = `${u.pathname}${u.search}`;
		if (!path.startsWith("/") || path.startsWith("//")) return "/pools";
		if (path.startsWith("/login")) return "/pools";
		return path;
	} catch {
		return "/pools";
	}
}

/** Login URL that sends members to `/pools` after sign-in (or immediately if already signed in). */
export function buildLoginUrlWithCallback(callbackPath = "/pools"): string {
	const base = getEmailPublicBaseUrl();
	const path = sanitizePostLoginPath(callbackPath);
	return `${base}/login?callbackUrl=${encodeURIComponent(path)}`;
}
